import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";
import { selectDropdowns, selectDropdownOptions } from '../../../redux/dropdownSlice'
import { useForm, Controller } from 'react-hook-form'
import Select from 'react-select'
import { reactSelectClassNames } from '../../../helpers/react-select-styles'
import { useRequest } from '../../../hooks/UseRequest'
import { setNotification } from '../../../redux/notificationSlice'
import { selectPaymentScheduleData } from "../../../redux/paymentScheduleDataSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import SpecialInstruction from '../../../components/elements/SpecialInstruction'
import { triggerRerender } from '../../../redux/rerenderSlice'
import Loading from "../../../components/Loading";
import TableHeader from "../../../components/TableHeader";
import TableRow from "../../../components/TableRow";
import { selectMultiSelectedRows, setSelectedRows } from "../../../redux/multiSelectRowSlice";

export default function WaiveModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const dropdowns = useSelector(selectDropdowns);
  const dropdownOptions = useSelector(selectDropdownOptions);
  const paymentScheduleData = useSelector(selectPaymentScheduleData)
  const customerId = modal.options?.customerId
  const multiSelectedRows = useSelector(selectMultiSelectedRows)

  const discountReasonWaive = dropdowns.data.filter((o) => o.code_key === 'discount_reason')[0];
  const creditReportTypeDropdown = dropdowns.data.filter((o) => o.code_key === 'credit_report_type')[0];

  const discountReasonWaiveOptions = dropdownOptions.filter((o) => o.dropdown_id === discountReasonWaive.id && o.code_key.includes('discount_reason_waive')).map((o) => ({ label: o.name, value: o.id, codeKey: o.code_key, documents: o.optional_value_4 }));
  const waiveReportTypeOptions = dropdownOptions
    .filter((o) => o.dropdown_id === creditReportTypeDropdown.id && ['credit_report_type_good_settlement', 'credit_report_type_delinquent_settlement', 'credit_report_type_void_general'].includes(o.code_key))
    .map((o) => {
      let label = o.name;
      if (o.code_key === 'credit_report_type_void_general') {
        label = 'Delete Tradelines'
      }
      return ({ label: label, value: o.id, codeKey: o.code_key })
    });

  const { register, handleSubmit, control, watch, setValue, formState: { errors }, reset } = useForm();
  const [saving, setSaving] = useState(false)
  const request = useRequest()
  const loanId = modal.options?.loanId
  const [files, setFiles] = useState([]);
  const [discountReasonDdo, setDiscountReasonDdo] = useState(null);
  const [isLoadingWaiveDocument, setIsLoadingWaiveDocument] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [documentRequires, setDocumentRequires] = useState([]);
  const fileInputRef = useRef([])
  // Bumped on every reset so a document lookup started for a previous loan or reason is ignored.
  const documentRequestId = useRef(0)

  const documentWaiveFields = [
    { label_name: 'File Name', column_name: 'label', list_size: 1, is_editable: false, is_user_sortable: false, is_show_in_subpanel_view: 1, helper_text: null, module_field_type_dropdown_option_id: 1054 },
    { label_name: 'Type', column_name: 'document_type_dropdown_option_id', list_size: 1, is_editable: false, is_user_sortable: false, is_show_in_subpanel_view: 1, helper_text: null, module_field_type_dropdown_option_id: 1061, dropdown_key: 'document_type' },
    { label_name: 'Loan', column_name: 'loan_id', list_size: 1, is_editable: true, is_user_sortable: false, is_show_in_subpanel_view: 1, helper_text: null, module_field_type_dropdown_option_id: 1062 },
    { label_name: 'File', column_name: 's3_link', list_size: 1, is_editable: true, is_user_sortable: false, is_show_in_subpanel_view: 1, helper_text: null, module_field_type_dropdown_option_id: 1757 },
    { label_name: 'Created At', column_name: 'created_at', list_size: 1, is_editable: true, is_user_sortable: false, is_show_in_subpanel_view: 1, helper_text: null, module_field_type_dropdown_option_id: 1059 },
    { label_name: 'Created By', column_name: 'created_by', list_size: 1, is_editable: true, is_user_sortable: false, is_show_in_subpanel_view: 1, helper_text: null, module_field_type_dropdown_option_id: 1055 },
  ]

  const handleCancel = () => {
    resetData();
    dispatch(setModal({ is_active: false }));
  };

  const resetData = (isAll = true) => {
    documentRequestId.current += 1
    setIsLoadingWaiveDocument(false)
    setFiles([]);
    setUploadedDocuments([])
    setDocumentRequires([])

    reset({
      is_refund: false,
    });

    if (isAll) {
      reset({
        discount_reason_dropdown_option_id: ''
      });
      setDiscountReasonDdo(null);
    }
  }

  const handleWaiveDDOChange = (val) => {
    setDiscountReasonDdo(val)
    resetData(false)
  };

   useEffect(() => {
    if (discountReasonDdo?.documents) {
        getUploadDocumentRequired()
    }
  }, [discountReasonDdo])

  const getUploadDocumentRequired = async () => {
    const requestId = ++documentRequestId.current
    setIsLoadingWaiveDocument(true)

      // Get document type IDs from discountReasonDdo.documents (comma-separated code keys)
    const documentCodeKeys = discountReasonDdo?.documents?.split(',') || [];
    const documentTypes = documentCodeKeys
      .map((codeKey) => {
        return dropdownOptions.filter((o) => o.code_key === codeKey.trim())[0];
      });
    setDocumentRequires(documentTypes);
    const documentTypeIds = documentTypes.map((dt) => dt.id);

    const filterQuery = {
      and: [
        { column: 'customer_id', value: customerId, operator: '=' },
        { column: 'loan_id', value: loanId, operator: '=' },
        { column: 'is_active', value: true, operator: '=' },
        { column: 'document_type_dropdown_option_id', value: documentTypeIds, operator: 'in' },
      ],
    };
    request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/document?filters=${JSON.stringify(filterQuery)}`)
    const response = await request.get()
    // This modal stays mounted in the Footer; a late response for a previous loan must not mark its
    // documents as already uploaded (or replaceable) for this one.
    if (requestId !== documentRequestId.current) return
    setIsLoadingWaiveDocument(false)
    setUploadedDocuments(response?.data?.data || [])

    dispatch(setSelectedRows({ isAll: true, selectedRows: response?.data?.data.map((doc) => doc.id) }));
  }

  const shouldUploadDocument = (doc) => {
    // Show if no uploaded documents exist
    if (!uploadedDocuments || uploadedDocuments.length === 0) {
      return true;
    }

    // Get uploaded documents that match the current document type
    const matchingUploadedDocs = uploadedDocuments.filter(
      (uploadedDoc) => uploadedDoc.document_type_dropdown_option_id === doc.id
    );

    // Show if all rows are selected
    if (multiSelectedRows.isAll && matchingUploadedDocs.length > 0) {
      return false;
    }

    // Show if none of the matching uploaded documents are selected
    const hasSelectedMatchingDoc = matchingUploadedDocs.some(
      (filteredDoc) => multiSelectedRows.selectedRows.includes(filteredDoc.id)
    );

    return !hasSelectedMatchingDoc;
  };

   useEffect(() => {
      if (multiSelectedRows.isAll) {
        setFiles([]);
      } else {
        const filteredFiles = files.filter((file) => !multiSelectedRows.selectedRows.includes(file.replace_file_id));
        setFiles(filteredFiles);
      }
   }, [multiSelectedRows])

  const onSubmit = async (formData) => {
    let hasUploadedFile = true;
    documentRequires.forEach((doc) => {
      if (shouldUploadDocument(doc) && !files.some((file) => file.type === doc.code_key)) {
        hasUploadedFile = false;
      }
    });

    if (hasUploadedFile) {
      setSaving(true)
      request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/customer/${customerId}/payment_schedule/waive`)
      try {
        formData.discount_reason_dropdown_option_id = formData.discount_reason_dropdown_option_id.value;

        if (formData.credit_report_type_dropdown_option_id?.value) {
          formData.credit_report_type_dropdown_option_id = formData.credit_report_type_dropdown_option_id.value;
        }

        if (paymentScheduleData?.paymentScheduleCurrentDate !== null) {
          formData.current_date = paymentScheduleData?.paymentScheduleCurrentDate;
        }

        if (loanId) {
          formData.loan_id = loanId;
        }

        const response = await request.modify(formData, files, true)
        if (response.status === 200 || response.status === 201) {
          setSaving(false)
          dispatch(setModal({ is_active: false }));
          dispatch(setNotification({ type: 'success', body: '' }))
          modal.options?.successCallback()
          dispatch(triggerRerender({ subpanelId: 'document' }))
          if (typeof paymentScheduleData.refreshPaymentSchedule === 'function') {
            await paymentScheduleData.refreshPaymentSchedule()
          }
        } else {
          setSaving(false)
          resetData();
          dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
        }
      } catch (error) {
        setSaving(false)
        resetData();
        const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
        dispatch(setNotification({ type: 'error', body: errorMessage }))
      }
    } else {
      dispatch(setNotification({ type: 'error', body: "Please upload required file(s) or select file(s) to replace." }))
    }
  };

  useEffect(() => {
    resetData();
  }, [modal.is_active])

  return modal.is_active && modal.type === 'waive_loan_modal' ? (
    <form onSubmit={handleSubmit(onSubmit)} id="waive_loan_modal_form">
      <div className="modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card is-flex is-flex-direction-column column is-7">
          <header className="modal-card-head py-3">
            <p className="modal-card-title is-capitalized">
              Waive(Legal) Loan
            </p>
            <button className="delete" aria-label="close" onClick={handleCancel}></button>
          </header>
          <section
            className="modal-card-body modal-card-body pt-1 pb-1"
            style={{ minHeight: "110px", overflow: 'hidden' }}
          >
            <div className="columns mb-0 is-flex-direction-column">
              <div className="column">
                <h3 className="has-text-danger">IMPORTANT: This will waive all future payments and close the loan.</h3>
                <br />
                <h3>Select Reason <span className="has-text-danger">*</span></h3>
              </div>
              <div className="column">
                <Controller
                  name="discount_reason_dropdown_option_id"
                  control={control}
                  rules={{ required: 'Please select a reason' }}
                  render={({ field }) => {
                    return (
                      <Select
                        {...field}
                        options={discountReasonWaiveOptions}
                        isSearchable={false}
                        classNames={reactSelectClassNames(errors, 'discount_reason_dropdown_option_id')}
                        menuPosition="fixed"
                        styles={{
                          container: (base) => ({ ...base, width: '100%' }),
                          menu: ({ ...css }) => ({ ...css, width: '100%' }),
                        }}
                        onChange={(val) => {
                          handleWaiveDDOChange(val)
                          setTimeout(() => {
                            field.onChange({ label: val?.label, value: val?.value })
                          }, 0)
                        }}
                        form="waive_loan_modal_form"
                      />
                    )
                  }}
                />
                {errors?.discount_reason_dropdown_option_id?.message &&
                  <p className="has-text-danger">{errors?.discount_reason_dropdown_option_id?.message}</p>}
              </div>
              <div className="column">
                <h3>Select Report Type</h3>
              </div>
              <div className="column">
                <Controller
                  name="credit_report_type_dropdown_option_id"
                  control={control}
                  render={({ field }) => {
                    return (
                      <Select
                        {...field}
                        options={waiveReportTypeOptions}
                        isSearchable={false}
                        classNames={reactSelectClassNames(errors, 'credit_report_type_dropdown_option_id')}
                        menuPosition="fixed"
                        isClearable
                        styles={{
                          container: (base) => ({ ...base, width: '100%' }),
                          menu: ({ ...css }) => ({ ...css, width: '100%' }),
                        }}
                        onChange={(val) => {
                          field.onChange(val ? { label: val?.label, value: (val?.value) } : null);
                        }}
                        form="waive_loan_modal_form"
                      />
                    )
                  }}
                />
                {errors?.credit_report_type_dropdown_option_id?.message &&
                  <p className="has-text-danger">{errors?.credit_report_type_dropdown_option_id?.message}</p>}
              </div>
              <div className="column">
                <h3>IMPORTANT: Compliance team will work with the tribe to determine whether to refund any payments the
                  customer has already made. </h3>
              </div>
              <div className="column">
                <label>
                  <Controller
                    name="is_refund"
                    control={control}
                    defaultValue={false}
                    render={({ field }) => (
                      <input
                        {...field}
                        type="checkbox"
                        checked={field.value}
                        onChange={(e) => {
                          field.onChange(e.target.checked)
                        }}
                      />
                    )}
                  /> Refund Payments Made <span
                    className={'lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-top has-tooltip-primary has-text-weight-normal'}
                    data-tooltip={`Do we need to refund all past paid payments? Compliance should work with the tribe to determine this.`}
                  >
                    <FontAwesomeIcon icon={faQuestionCircle} className="has-text-link" />
                  </span>
                </label><br />
              </div>

              {discountReasonDdo?.documents && (
                <>
                  <div className="column">
                    <h3>Required Documents {uploadedDocuments && uploadedDocuments.length > 0 && (<span className="has-text-link">(Deselect to upload new document)</span>)}</h3>
                  </div>
                  {isLoadingWaiveDocument && (
                    <div className="columns mb-0 is-flex-direction-column">
                      <div className="column">
                        <span className="has-text-center"><Loading /></span>
                      </div>
                    </div>
                  )}

                  {uploadedDocuments && uploadedDocuments.length > 0 && (
                    <table className="lox-sub-panel--table table is-bordered is-striped is-narrow is-hoverable is-fullwidth is-info">
                      <TableHeader columns={documentWaiveFields} hasActions={false} startId={0} hasMultiSelect hasView={false} isLightColor />
                      <tbody>
                        <TableRow rows={uploadedDocuments} hasMultiSelect columns={documentWaiveFields} hasActions={false} hasEdit={false} hasView={false} />
                      </tbody>
                    </table>
                  )}

                  {!isLoadingWaiveDocument && (
                    <>
                      {(documentRequires.map((doc, index) => {
                        return shouldUploadDocument(doc) && (
                          <div key={doc.id ?? index} className="column pl-5">
                            <h3>Upload {doc.name}<span className="has-text-danger">*</span>
                              <span
                                style={{ pointerEvents: 'auto' }}
                                className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary has-text-weight-normal`}
                                data-tooltip={'Supported file types: .pdf, .jpg, .jpeg, .png, .doc, .docx'}
                              >
                                <FontAwesomeIcon
                                  icon={faCircleInfo}
                                  className={`pl-1 has-text-link`}
                                />
                              </span>
                            </h3>
                            <div className="mt-1">
                              <Controller
                                control={control}
                                name={`file_` + doc.code_key}
                                render={({ field: { value, onChange, ...field } }) => {
                                  return (
                                    <input
                                      {...field}
                                      value={value?.fileName}
                                      onChange={(event) => {
                                        onChange(event.target.files[0])
                                        const fileObject = {
                                          file: event.target.files[0],
                                          type: doc.code_key,
                                          replace_file_id: uploadedDocuments.filter((f) => f.document_type_dropdown_option_id === doc.id)[0]?.id,
                                        }
                                        setFiles((prevFiles) => [
                                          ...prevFiles.filter((f) => f.type !== doc.code_key),
                                          fileObject
                                        ])
                                      }}
                                      type="file"
                                      ref={fileInputRef[doc.code_key]}
                                    />
                                  )
                                }}
                              />
                            </div>
                          </div>
                        )
                      }))}
                    </>
                  )}

                  <div className="column">
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    <h3>NOTE: You need to upload these documents to the customer's Documents.</h3>
                    <h3>NOTE 2: Leave a note with the CaseIQ ID # in it on the customer. </h3>
                  </div>
                </>
              )}
              <div className="column">
                <SpecialInstruction
                  content={'<span>' +
                    '<span class=\'has-text-weight-bold\'>This will perform the following actions:</span><br>' +
                    '<span class=\'pl-2\'>• Waive all future payments</span> <br> ' +
                    '<span class=\'pl-2\'>• Close the loan</span> <br> ' +
                    '<span class=\'pl-2\'>• Report to bureaus as loan VOID</span> <br> ' +
                    '<span class=\'pl-2\'>• IF Refund checkbox checked</span> <br> ' +
                    '<span class=\'pl-4\'>o All future payments will be soft-deleted from the schedule</span> <br> ' +
                    ' </span>'}
                  type="is-warning"
                />
              </div>
            </div>
          </section>
          <footer className="modal-card-foot is-justify-content-end py-1">
            <div className="lox-form__buttons-wrapper has-text-right">
              <button
                type="button"
                className="button is-small has-background-grey has-text-white"
                onClick={handleCancel}
              >Cancel
              </button>
              <button
                type="submit"
                className="button is-danger is-small"
                disabled={saving && 'disabled'}
              >{saving ? 'Submitting' : 'Waive Loan'}</button>
            </div>
          </footer>
        </div>
      </div>
    </form>
  ) : null;
}
